import styled from '@emotion/styled';
import { HTMLAttributes, forwardRef } from 'react';

export interface BubbleMessageProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
}
const Bubble = styled.div<{ color: string }>`
  max-width: 800px;
  min-width: 16px;
  padding: 12px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  display: inline-block;
`;
const BubbleMessage = forwardRef<HTMLDivElement, BubbleMessageProps>((props, ref) => {
  const { className, color = '#fff', ...otherProps } = props;
  return <Bubble ref={ref} color={color} className={className} {...otherProps} />;
});
export default BubbleMessage;
